// Lebar panel chatbot + breakpoint — single source of truth
// Dipakai bersama oleh Chatbot/index.tsx (lebar panel & FAB) dan
// SidebarLayout/index.tsx (push content margin di layar XL).

export const CHATBOT_SM_BREAKPOINT = 600;   // < 600px = fullscreen Dialog
export const CHATBOT_MD_BREAKPOINT = 960;   // 600-959px = panel fixed
export const CHATBOT_XL_BREAKPOINT = 1840;  // >= 1840px = push content (theme xl)
export const CHATBOT_PANEL_MIN = 500;       // lebar minimum panel (user: jangan terlalu kecil)
export const CHATBOT_PANEL_MID = 640;       // cap overlay 960-1839px
export const CHATBOT_XL_PANEL_WIDTH = 760;  // panel tetap di layar XL (push content)

export function getChatbotPanelWidth(vw: number): number {
  if (vw < CHATBOT_SM_BREAKPOINT) return 0;                   // fullscreen, width tidak dipakai
  if (vw < CHATBOT_MD_BREAKPOINT) return CHATBOT_PANEL_MIN;   // fixed 500
  if (vw < CHATBOT_XL_BREAKPOINT) {
    return Math.max(CHATBOT_PANEL_MIN, Math.min(CHATBOT_PANEL_MID, Math.round(vw * 0.5)));
  }
  return CHATBOT_XL_PANEL_WIDTH;                              // push content 760
}
